// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"e3e543dd","524":"9f12c725","583":"ebfdc2ed","673":"fc6b4349","767":"a95c1adc","876":"79407ffc"}[chunkId] + ".chunk.js";
};